import { PropsWithChildren } from 'react';

import { PropsWithCN, cn } from '@tg-web/utils';

export type IslandSectionHeaderProps = PropsWithChildren & PropsWithCN;

/**
 * A heading above an island.
 *
 * It owns its own spacing, so a screen only has to place it in the usual
 * `gap-3` island column: the column's 12px carries the header down to its
 * island, and the extra 12px here makes 24px from whatever sits above. No
 * screen needs to know those numbers.
 *
 * `first:mt-0` is for a header that opens a column with nothing above it —
 * there is no gap to add to, so the extra 12px would be a stray indent. A
 * header under a screen title is not first, and gets the full 24px, which is
 * what the design asks for.
 */
export function IslandSectionHeader({
  children,
  className,
}: IslandSectionHeaderProps) {
  return (
    <p className={cn('typo-text-bold text-tg-text mt-3 first:mt-0', className)}>
      {children}
    </p>
  );
}
